import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NgrxStoreKeys } from '@warema/warema-plus/models';
import { AppointmentMetadataState } from './appointment-metadata.reducer';

const selectFeatureAppointmentDetailsState = createFeatureSelector<AppointmentMetadataState>(
    NgrxStoreKeys.APPOINTMENT_METADATA_FEATURE_KEY,
);

export const selectAppointmentRequestQueryId = createSelector(
    selectFeatureAppointmentDetailsState,
    (state: AppointmentMetadataState) => state.appointmentRequestQuery?.id ?? null,
);
